<template>
    <v-container fluid>
        <v-container v-if="!!openRounds.length">
            <v-layout>
                <v-flex>
                    <h2>Actualmente tiene rondas sin cerrar</h2>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex>
                    <v-btn color="warning" block @click="$router.push({ name: 'openRounds' })"
                        >Ver Rondas Abiertas</v-btn
                    >
                </v-flex>
            </v-layout>
        </v-container>

        <v-container>
            <v-layout>
                <v-flex>
                    <h2>Seleccione el Cliente</h2>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex>
                    <v-autocomplete
                        :items="clients"
                        item-text="name"
                        item-value="id"
                        hide-no-data
                        hide-selected
                        label="Cliente"
                        v-model="selectedClientId"
                    ></v-autocomplete>
                </v-flex>
            </v-layout>

            <v-card v-for="round in rounds" :key="round.id" class="mt-2">
                <v-card-title
                    ><h4>Ronda: {{ round.name }}</h4></v-card-title
                >
                <v-card-text>
                    <v-layout>
                        <v-flex xs12>Sede: {{ round.venue_name }}</v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12>Puesto: {{ round.service_spot_name }}</v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12>Checklist: {{ round.check_list.length }}</v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12>Puntos de control: {{ round.control_points.length }}</v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" block @click="beginRound(round)">Iniciar Ronda</v-btn>
                </v-card-actions>
            </v-card>
        </v-container>

        <v-layout>
            <v-flex>
                <app-last-rounds ref="last-rounds"></app-last-rounds>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { QrcodeStream } from 'vue-qrcode-reader'
import Assignations from '../components/widgets/Assignations'
import { getDistanceFromCoords } from '../utils/geolocation'
import LastRounds from '../components/widgets/LastRounds/LastRounds'

export default {
    components: {
        appAssignations: Assignations,
        QrcodeStream,
        appLastRounds: LastRounds,
    },
    data: () => ({
        reading: false,
        headers,
        clients: [],
        selectedClientId: '',
    }),
    watch: {
        selectedClient(val) {
            this.setClient(val)
            this.$nextTick(() => this.$refs['last-rounds'].loadLastRounds())
        },
    },
    computed: {
        ...mapGetters(['assignations', 'updateAvailable', 'openRounds']),
        selectedClient() {
            if (!this.selectedClientId) return null
            return this.clients.find(item => item.id === this.selectedClientId)
        },
        rounds() {
            if (!this.selectedClient) return []
            return this.selectedClient.rounds
        },
    },
    methods: {
        ...mapActions(['startRound', 'loadLastRounds', 'loadOpenRounds']),
        ...mapMutations({
            setClient: 'client',
            setCurrentRound: 'currentRound',
            setOpenRounds: 'setOpenRounds',
        }),
        startReading() {
            this.reading = true
        },
        readingOff() {
            this.reading = false
        },
        onDecode(str) {
            this.readingOff()
            const point = JSON.parse(str)

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(pos => {
                    const { latitude, longitude } = pos.coords
                    this.runRound(point, latitude, longitude)
                })
            }
        },
        runRound(point, latitude, longitude) {
            const round = this.rounds.find(
                item => !!item.control_points.find(p => p.id === point.controlPointId)
            )

            if (!round) return toastr.error('No esta habilitado para ejecutar esta ronda')

            this.setClient(round.client)

            if (!round) toastr.error('No se encontró información para iniciar la ronda')

            this.setCurrentRound(round)

            const startDate = this.$dt.now()

            const selectedPoint = this.currentRound.control_points.find(
                item => item.id === point.controlPointId
            )

            const roundInProgress = {
                ...this.roundInProgress,
                startDate,
                userId: this.user.id,
                currentRound: this.currentRound,
            }

            const checkPoints = [...roundInProgress.checkPoints]

            const distance = getDistanceFromCoords(
                selectedPoint.latitude,
                selectedPoint.longitude,
                latitude,
                longitude
            )

            checkPoints.push({
                id: selectedPoint.id,
                checkpointDate: this.$dt.now(),
                distance,
                latitude,
                longitude,
            })

            this.setRoundInProgress({ ...roundInProgress, checkPoints })

            // Iniciar la ronda asincronamente
            this.startRound({ roundId: round.id, startDate, userId: this.user.id }).then(resp =>
                this.setRoundInProgress({ ...this.roundInProgress, id: resp.instance.id })
            )

            this.$router.push({ name: 'roundInProgress' })
        },
        updateApp() {},
        async loadClients() {
            const { data } = await this.$repo.get('rounds/clients')
            this.clients = data
        },
        beginRound(round) {
            if (!!this.openRounds.length)
                return toastr.error(
                    'Tiene rondas abiertas. Por favor cierrelas o finalicelas antes de iniciar una nueva'
                )

            this.setClient(this.selectedClient)
            this.setCurrentRound(round)

            const startDate = this.$dt.now()
            const roundInProgress = {
                ...this.roundInProgress,
                startDate,
                userId: this.user.id,
                currentRound: this.currentRound,
            }
            const checkPoints = [...roundInProgress.checkPoints]
            this.setRoundInProgress({ ...roundInProgress, checkPoints })
            this.startRound({ roundId: round.id, startDate, userId: this.user.id }).then(resp => {
                this.setRoundInProgress({ ...this.roundInProgress, id: resp.instance.id })
                this.$router.push({ name: 'roundInProgress' })
            })
        },
    },
    mounted() {
        // this.loadAssignations();
        this.loadRoundInProgress()
        // this.loadLastRounds()
        this.loadClients()

        if (this.client) {
            this.selectedClientId = this.client.id
        }

        this.loadOpenRounds()
    },
}

const headers = [
    {
        text: 'Ronda',
        value: 'name',
    },
    {
        text: 'Puntos',
        value: 'control_points.length',
    },
    {
        text: 'Items',
        value: 'check_list.length',
    },
]
</script>
<style lang="css">
.update-button {
    width: 90%;
    height: 50px;
    position: fixed;
    top: 100%;
    margin-top: -50px;
}
</style>
